import { Flex, Result } from 'antd';
import React from 'react';

const ComingSoon = () => {
    return (
        <Flex
            justify="center"
            align="center"
            style={{
                height: '100vh',
                width: '100%',
            }}
        >
            <Result
                status="info"
                title="Coming Soon"
                subTitle="We are working hard to bring you something amazing. Stay tuned."
            />
        </Flex>
    );
};

export default ComingSoon;
